import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import twemoji from "twemoji";

const getEmojiUrl = (unicode) => {
  return `${twemoji.base}svg/${unicode}.svg`;
};

const EMOJI_OPTIONS = [
  { value: "none", unicode: null, label: "No Face (Show Points)" },
  { value: "smile", unicode: "1f60a", label: "Smiling with Eyes" },
  { value: "grin", unicode: "1f600", label: "Grinning Face" },
  { value: "grinning", unicode: "1f603", label: "Big Grin" },
  { value: "beam", unicode: "1f601", label: "Beaming" },
  { value: "slight", unicode: "1f642", label: "Slight Smile" },
];

const SettingsDialog = ({
  open,
  onClose,
  height,
  setHeight,
  weight,
  setWeight,
  cameraId,
  handleCameraChange,
  cameras,
  faceExpression,
  setFaceExpression,
  theme,
  setTheme,
  onSave,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Settings</DialogTitle>
      <DialogContent style={{ minWidth: "300px", paddingTop: "20px" }}>
        <FormControl fullWidth style={{ marginBottom: "20px" }}>
          <InputLabel id="camera-select-label">Camera</InputLabel>
          <Select
            labelId="camera-select-label"
            value={cameraId}
            label="Camera"
            onChange={handleCameraChange}
          >
            <MenuItem value="">Auto (System Default)</MenuItem>
            {cameras}
          </Select>
        </FormControl>

        <TextField
          label="Height (cm)"
          type="number"
          value={height}
          onChange={(e) => setHeight(parseFloat(e.target.value) || 0)}
          fullWidth
          style={{ marginBottom: "20px" }}
        />

        <TextField
          label="Weight (kg)"
          type="number"
          value={weight}
          onChange={(e) => setWeight(parseFloat(e.target.value) || 0)}
          fullWidth
          style={{ marginBottom: "20px" }}
        />

        <FormControl fullWidth style={{ marginBottom: "20px" }}>
          <InputLabel id="emoji-provider-label">Face Expression</InputLabel>
          <Select
            labelId="emoji-provider-label"
            value={faceExpression}
            label="Face Expression"
            onChange={(e) => setFaceExpression(e.target.value)}
          >
            {EMOJI_OPTIONS.map((emoji) => (
              <MenuItem key={emoji.value} value={emoji.value}>
                {emoji.unicode ? (
                  <img
                    src={getEmojiUrl(emoji.unicode)}
                    alt=""
                    style={{ width: 20, height: 20, marginRight: 8 }}
                  />
                ) : (
                  <span style={{ width: 20, height: 20, marginRight: 8, display: 'inline-block' }} />
                )}
                {emoji.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box style={{ marginBottom: "20px" }}>
          <InputLabel style={{ marginBottom: "10px" }}>Theme</InputLabel>
          <ToggleButtonGroup
            value={theme}
            exclusive
            onChange={(e, newTheme) => newTheme && setTheme(newTheme)}
            fullWidth
          >
            <ToggleButton value="light">Light</ToggleButton>
            <ToggleButton value="system">System</ToggleButton>
            <ToggleButton value="dark">Dark</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Button
          variant="contained"
          onClick={onSave}
          fullWidth
          style={{ background: "#4caf50" }}
        >
          Save Settings
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsDialog;
